import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import ContactModel from 'donor-elf-web/models/contact';
import ReviewItemModel from 'donor-elf-web/models/review-item';

interface ContactReviewItemsComponentArgs {
  contact: ContactModel;
  model: ReviewItemModel[];
  onSave: (item: ReviewItemModel) => void;
}

export default class ContactReviewItemsComponent extends Component<ContactReviewItemsComponentArgs> {
  constructor(owner: any, args: ContactReviewItemsComponentArgs) {
    super(owner, args);

    this.reviewItems = this.args.model;
  }

  @tracked reviewItems: ReviewItemModel[];

  @action
  handleSave(item: ReviewItemModel) {
    setTimeout(() => {
      this.reviewItems = this.reviewItems.filter((x) => x.id !== item.id);
      this.args.onSave(item);
    }, 800);
  }
}
